<template>
    <div class="container">
        <div class="message-border text-center">
            <h4 class="heading">Please verify your email</h4>
            <br />
            <div>
                <p>
                    Almost there! An email containing verification instructions
                    was sent to<br /><span style="color: #019382">
                        {{ name }}
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "EmailSent",

    data() {
        return {
            name: "your email inbox",
        };
    },

    created() {
        this.$store.state.pageState = "emailSent";
        if (JSON.parse(this.$store.state.user)) {
            this.name =
                JSON.parse(this.$store.state.user).firstName +
                " " +
                JSON.parse(this.$store.state.user).lastName;
        }
    },
    unmounted() {
        this.unsubscribe();
    },

    methods: {
        ...mapActions(["getUser"]),
    },
};
</script>

<style scoped>
.container {
    box-sizing: border-box;
    max-width: 1123px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
    padding-top: 3%;
    padding-bottom: 12%;
}

.message-border {
    border: 2px solid #d8d8d8;
    width: 600px;
    padding: 30px;
    padding-bottom: 50px;
    margin: auto;
    border-radius: 25px;
}

.heading {
    font-weight: 700;
    font-size: 29px;
    line-height: 34px;
    color: #1978a0;
}

hr {
    border: 2px solid #d8d8d8;
}

.btn1 {
    background: #019382;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    width: 319px;
    height: 45px;
}

.list-group-item {
    text-align: left;
    background: #f6f5f5;
    font-size: 16px;
    line-height: 19px;
    color: #5a7d95;
}

.list-group .active {
    background: #1978a0;
    color: #ffffff;
}
@media (max-width: 600px) {
    .heading {
        font-size: 18px !important;
    }
    .btn1 {
        width: 66.78% !important;
        font-size: 80% !important;
    }
}
</style>
